import type { GoalZoneDoctorSummary } from "@care-by-ella/contracts";
import { goalZoneLines } from "@/lib/goal-zone-lines";

// TES-998 (Ö-238) — see goal-zone-lines.ts for what is shown and why.
export function GoalZoneNote({
  summary,
  className,
}: {
  summary: GoalZoneDoctorSummary | null | undefined;
  className?: string;
}) {
  const lines = goalZoneLines(summary);
  if (lines.length === 0) return null;
  return (
    <div className={className ?? "mt-xs text-xs text-textSecondary"}>
      {lines.map((l) => (
        <p key={l}>{l}</p>
      ))}
    </div>
  );
}
